import React from "react";
import { Layout } from "antd";
import Navigation from "./components/navigation";
import UserInfoBar from "./components/user-info";
import Breadcrumbs from "./components/breadcrumbs";
import PrivateRoutes from "Routes/private";

const { Content, Footer, Header } = Layout;

const PrivateLayout = ({ ...props }) => {
  return (
    <Layout>
      <Header className="customized">
        <Navigation />
        <UserInfoBar />
      </Header>
      <Content className="customized">
        <Breadcrumbs />
        <div className="inner-content">
          <PrivateRoutes />
        </div>
      </Content>
      <Footer className="customized">
        <center>©2020 Vektora - Varlık Yönetimi</center>
      </Footer>
    </Layout>
  );
};

export default PrivateLayout;
